import { cn } from '@/lib/utils';

const roleConfig: Record<string, { text: string; bg: string }> = {
  owner:     { text: '#FFFFFF', bg: '#1F2937' },
  admin:     { text: '#FFFFFF', bg: '#374151' },
  moderator: { text: '#374151', bg: '#F3F4F6' },
  leader:    { text: '#374151', bg: '#F3F4F6' },
  member:    { text: '#374151', bg: '#F3F4F6' },
  user:      { text: '#374151', bg: '#F3F4F6' },
};

interface RoleBadgeProps {
  role: string;
  className?: string;
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const config = roleConfig[role] ?? roleConfig.member!;
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', className)}
      style={{ color: config.text, backgroundColor: config.bg }}
    >
      {role.charAt(0).toUpperCase() + role.slice(1)}
    </span>
  );
}
